import { Model } from "../../../../shared/models/model";

export class MenuConfig extends Model {}
